import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Page } from '@/model/document2/page/page';
import { Design } from '@/model/document2/page/surface/design/design';
import { DocumentHelper } from '@/helper/documentHelper';

// デザインのコピーコマンド
export class CopyDesignCommand implements ICommandBase
{
    private design! : Design;
    private position! : number;
    private page! : Page;
    private isReverse! : boolean;
    private doneCallback! : () => void;

    private orgDesign : Design | null;

    constructor(design : Design, position : number, page : Page, isReverse : boolean, doneCallback : () => void)
    {
        this.design = design;
        this.position = position;
        this.page = page;
        this.isReverse = isReverse;
        this.doneCallback = doneCallback;
        
        // コピー先の元のデザインを保持(存在しない場合はnull)
        this.orgDesign = page.getSurface(isReverse).getDesign(position);
    }

    private get surface() { return this.page.getSurface(this.isReverse); }

    public do() : void
    {
        // コピー元の複製をとる。
        var clonedDesign = this.design.clone();
        // 連番のクローンを取り消す
        DocumentHelper.unityNumberLayersLink(clonedDesign, this.design);
        // リサイズ
        var designRect = this.surface.getDesignRect(this.position);
        clonedDesign.width = clonedDesign.rotate == 90 || clonedDesign.rotate == 270 ? designRect.height : designRect.width;
        clonedDesign.height = clonedDesign.rotate == 90 || clonedDesign.rotate == 270 ? designRect.width : designRect.height;
        // 複製をコピー先にセット。
        this.surface.setDesign(this.position, clonedDesign);
        
        this.doneCallback();
    }

    public undo() : void
    {
        if(this.orgDesign != null)
        {
            // 元のデザインをコピー先にセット。
            this.surface.setDesign(this.position, this.orgDesign);
        }
        else
        {
            // コピーしたデザインを削除。
            this.surface.removeDesign(this.position);
        }

        this.doneCallback();
    }

    public redo() : void
    {
        // コピー元の複製をとる。
        var clonedDesign = this.design.clone();
        // 連番のクローンを取り消す
        DocumentHelper.unityNumberLayersLink(clonedDesign, this.design);
        // リサイズ
        var designRect = this.surface.getDesignRect(this.position);
        clonedDesign.width = clonedDesign.rotate == 90 || clonedDesign.rotate == 270 ? designRect.height : designRect.width;
        clonedDesign.height = clonedDesign.rotate == 90 || clonedDesign.rotate == 270 ? designRect.width : designRect.height;
        // 複製をコピー先にセット。
        this.surface.setDesign(this.position, clonedDesign);

        this.doneCallback();
    }
}
